import { Image } from "element-tiptap";
import CustomImageButton from "./CustomImageButton";

export default class CustomImage extends Image {
  menuBtnView(editorContext) {
    // `editorContext` contains useful properties like isActive, commands, and editor
    // You can use these properties in your custom component to control the behavior of the button
    return {
      component: CustomImageButton, // Replace "CustomImageButton" with the name of your custom image button component
      componentProps: {
        // Add props to pass to your custom image button component (if needed)
        isActive: editorContext.isActive.image(),
      },
      componentEvents: {
        // Add event listeners to your custom image button component (if needed)
        click: (data) => {
          editorContext.commands.image(data);
          editorContext.editor.focus(); // This ensures that the editor stays focused after adding the image
        },
      },
    };
  }
}
